import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface EventDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  modalName?: string;
  sessionName?: string | null;
  modalData: {
    mode: string;
    eventName: string;
    date: string;
    time: string;
    location: string;
    classroom: string;
    instructors: string;
  }[];
}

const EventDetailsModal: React.FC<EventDetailsModalProps> = ({
  isOpen,
  onClose,
  modalData,
  modalName = "Event Details",
  sessionName,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white p-4 md:p-6 rounded shadow-lg max-h-[90vh] overflow-y-auto w-full max-w-5xl">
        <h2 className="text-lg md:text-xl font-semibold mb-4 text-center">
          {t(modalName)} {sessionName ? `- ${sessionName}` : ""}
        </h2>

        <div className="overflow-x-auto">
          <table className="table-auto w-full border-collapse text-sm md:text-base">
            <thead className="bg-[#961e38] text-white">
              <tr>
                <th className="border-b py-2 px-2 md:px-4 text-center">
                  {t("Event Name")}
                </th>
                <th className="border-b py-2 px-2 md:px-4 text-center">
                  {t("Date")}
                </th>
                <th className="border-b py-2 px-2 md:px-4 text-center">
                  {t("Time")}
                </th>
                <th className="border-b py-2 px-2 md:px-4 text-center">
                  {t("Type")}
                </th>
                <th className="border-b py-2 px-2 md:px-4 text-center">
                  {t("Location")}
                </th>
                <th className="border-b py-2 px-2 md:px-4 text-center">
                  {t("Classroom")}
                </th>
                <th className="border-b py-2 px-2 md:px-4 text-center">
                  {t("Instructors")}
                </th>
              </tr>
            </thead>
            <tbody>
              {modalData.map((event, idx) => (
                <tr key={idx}>
                  <td className="border-b py-2 px-2 md:px-4 text-center">
                    {event.eventName}
                  </td>
                  <td className="border-b py-2 px-2 md:px-4 text-center">
                    {event.date}
                  </td>
                  <td className="border-b py-2 px-2 md:px-4 text-center">
                    {event.time}
                  </td>
                  <td className="border-b py-2 px-2 md:px-4 text-center">
                    {event?.mode === "onsite"
                      ? t("Physical attendance")
                      : t("Online")}
                  </td>
                  <td className="border-b py-2 px-2 md:px-4 text-center">
                    {event.location}
                  </td>
                  <td className="border-b py-2 px-2 md:px-4 text-center">
                    {event.classroom}
                  </td>
                  <td className="border-b py-2 px-2 md:px-4 text-center">
                    {event.instructors
                      ? event.instructors === "Unknown"
                        ? t("TBD")
                        : event.instructors
                            .split(",")
                            .map((instructor, index, array) => (
                              <span key={index}>
                                {instructor.trim()}
                                {index !== array.length - 1 && ","} <br />
                              </span>
                            ))
                      : t("N/A")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-4">
          <button
            onClick={onClose}
            className="py-2 px-6 bg-red-500 hover:bg-red-600 text-white rounded transition"
          >
            {t("Close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventDetailsModal;
